import * as types from './Types'

const initialState = {
    loadBikeName: [],
    loadBikeModel: [],
    loadBikeFuel: [],
    loadBikeVariant: [],
    loadBikeRTO: [],
    StateName: [],
    CityName: [],
    Relation: [],
    Occupation: [],
    PreviousInsurer: [],
    Insurer: [],
    Financer: {},
    BikeQuotes: [],
    PropsalRes: [],
    storeQuotesRequest: {},
    addRiders: {},
    SelectedBikeInfo: {},
    hdfcStateData: {},
    selectedProduct: {},
    SelectedBike: {},
    getGodigitKyc: {},
    isKycDone: {},
    KYCResStore: {},
    ownerData: {},
    PersonalInfo: {},
    VehicleInfoBike: {},
    documentUpload: {},
    AddInfo: {},
    AllQuotesData: [],
    vehicleAddInfo: {},
    loading: true
}

export const BikeReducers = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case types.GET_ALL_BIKE_MAKES:
            return {
                ...state,
                loadBikeName: payload,
                loading: false
            }
        case types.GET_ALL_BIKE_MODEL:
            return {
                ...state,
                loadBikeModel: payload,
                loading: false
            }
        case types.GET_FUEL:
            return {
                ...state,
                loadBikeFuel: payload,
                loading: false
            }
        case types.GET_ALL_BIKE_VARIANT:
            return {
                ...state,
                loadBikeVariant: payload,
                loading: false
            }
        case types.GET_ALL_BIKE_RTO:
            return {
                ...state,
                loadBikeRTO: payload,
                loading: false
            }
        case types.SELECTED_INSURER_DETAILS:
            return {
                ...state,
                selectedProduct: payload,
                loading: false
            }

        case types.QUOTES_REQUESTED_DATA:
            return {
                ...state,
                storeQuotesRequest: payload,
                loading: true
            }
        case types.GET_PROPOSAL:
            return {
                ...state,
                PropsalRes: payload,
                loading: true
            }

        // *********************************************************************** for Other  ******
        case types.OWNWE_DETAIL:
            return {
                ...state,
                ownerData: payload,
                loading: false
            }
        case types.PERSONAL_DETAILS:
            return {
                ...state,
                PersonalInfo: payload,
                loading: false
            }
        case types.VEHICLE_INFO_BIKE:
            return {
                ...state,
                VehicleInfoBike: payload,
                loading: false
            }
        case types.DOCUMENT_UPLOAD:
            return {
                ...state,
                documentUpload: payload,
                loading: false
            }
        case types.GET_PREVIOUS_INSURER:
            return {
                ...state,
                PreviousInsurer: payload,
                loading: false
            }
        case types.ADDRESS_DETAIL:
            return {
                ...state,
                AddInfo: payload,
                loading: false
            }
        case types.GET_ALL_CITY:
            return {
                ...state,
                CityName: payload,
                loading: false
            }
        case types.GET_ALL_RELATIONSHIP:
            return {
                ...state,
                Relation: payload,
                loading: false
            }
        case types.GET_ALL_OCCUPATIONS:
            return {
                ...state,
                Occupation: payload,
                loading: false
            }
        case types.GET_ALL_FINANCER:
            return {
                ...state,
                Financer: payload,
                loading: false
            }
        case types.GET_ALL_INSURER:
            return {
                ...state,
                Insurer: payload,
                loading: false
            }
        case types.GET_ALL_STATE:
            return {
                ...state,
                StateName: payload,
                loading: false
            }
        // *********************************************************************** Quotes  ******

        case types.GET_BIKE_QUOTES: {
            const incomingQuotes = Array.isArray(action.payload) ? action.payload : []
            const merged = [...state.BikeQuotes]

            incomingQuotes.forEach((quote) => {
                if (!quote || !quote.insurerId) return

                const existingIndex = merged.findIndex(q => q.insurerId === quote.insurerId)

                if (existingIndex >= 0) {
                    merged[existingIndex] = quote
                } else {
                    merged.push(quote)
                }
            })

            return {
                ...state,
                BikeQuotes: merged,
                loading: false
            }
        }

        case types.NOT_GET_QUOTES:
            const updatedQuotesMap = new Map()
            state.notQuotesData?.forEach(item => updatedQuotesMap.set(item.insurerLogo, item))
            action.payload.forEach(item => updatedQuotesMap.set(item.insurerLogo, item))
            const noUpdatedQuotesData = Array.from(updatedQuotesMap.values())
            return {
                ...state,
                notQuotesData: noUpdatedQuotesData,
                loading: false
            }

        case types.SELECTED_BIKE_DATA:
            return {
                ...state,
                SelectedBike: payload,
                loading: true
            }
        case types.ADD_RIDER:
            return {
                ...state,
                addRiders: payload,
                loading: false
            }
        case types.GET_KYC_DETAIL:
            return {
                ...state,
                getGodigitKyc: payload,
                loading: true
            }
        case types.ALL_GET_KYC_DETAIL:
            return {
                ...state,
                KYCResStore: payload,
                loading: true
            }
        case types.GET_GODIGIT_KYC_CONTROLLER:
            return {
                ...state,
                isKycDone: payload,
                loading: true
            }
        case types.STORE_HDFC_STATE_DATA:
            return {
                ...state,
                hdfcStateData: payload,
                loading: false
            }
        case types.SELECTED_BIKE_DETAILS:
            return {
                ...state,
                SelectedBikeInfo: payload,
                loading: false
            }

        case types.RESET_GET_QUOTES:
            return {
                ...state,
                BikeQuotes: initialState.BikeQuotes,
                notQuotesData: initialState.notQuotesData
            }

        case types.ERASE_BIKE_DETAILS:
            return {
                ...state,
                loadBikeName: initialState.loadBikeName,
                loadBikeModel: initialState.loadBikeModel,
                loadBikeFuel: initialState.loadBikeFuel,
                loadBikeVariant: initialState.loadBikeVariant,
                loadBikeRTO: initialState.loadBikeRTO,
                SelectedBike: initialState.SelectedBike,
                selectedProduct: initialState.selectedProduct,
                storeQuotesRequest: initialState.storeQuotesRequest
            }

        case types.RESET_PROPOSAL_RES: return {
            ...state,
            KYCResStore: initialState.KYCResStore,
            PropsalRes: initialState.PropsalRes,
            hdfcStateData: initialState.hdfcStateData
        }
        default:
            return state
    }
}
export default BikeReducers